<template>
    <div
        :class="{'ring-1 ring-gray-200':isBorder}"
        class="rounded overflow-hidden"
    >
        <table
            class="w-full table-base"
            :class="{'disabled':disabled, 'cursorPointer':cursorPointer}"
        >
            <thead>
                <slot name="thead" />
            </thead>
            <tbody class="divide-y divide-dashed">
                <slot name="tbody" />
            </tbody>
        </table>
    </div>
</template>

<script>
import { EUDC } from '@/utils/EUDC';

export default {
    props: {
        disabled: {
            type: Boolean,
            default: false
        },
        isBorder: {
            type: Boolean,
            default: true
        },
        cursorPointer: {
            type: Boolean,
            default: true
        }
    },
    setup() {
        EUDC();
    }
};
</script>
<style lang="scss" scoped>
:deep(.table-base) {
    thead tr td {
        @apply px-2 xl:px-4 py-2 text-base;
    }
    tbody tr td {
        @apply px-2 xl:px-4 py-3;
    }
    &:not(.disabled) {
        @apply gradient-primary;
        &.cursorPointer {
            tbody tr {
                @apply cursor-pointer lg:hover:bg-gray-50;
            }
        }
        thead {
            // @apply gradient-primary;
        }
        tbody tr {
            @apply odd:bg-white even:bg-blue-200 lg:text-lg text-gray-700;

            &.disabled {
                @apply bg-gray-50 lg:text-lg text-gray-200 border-b border-dashed last:border-0 cursor-not-allowed;
            }
        }
    }
    &.disabled {
        thead {
            @apply bg-gray-200 text-white;
        }
        tbody tr {
            @apply bg-gray-50 lg:text-lg text-gray-200 border-b border-dashed last:border-0 cursor-not-allowed;
        }
    }
}
</style>
